import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Drop-in replacement for <input type="password"> with a show/hide toggle,
// so users can check what they typed. Takes the same props as an input
// (className, value, onChange, ...). The default icon colour is a mid grey
// that stays visible on both the dark login card and the white background
// browsers paint on autofilled fields.
export default function PasswordInput({ toggleColor = '#7b8794', style, ...inputProps }) {
    const [visible, setVisible] = useState(false);

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <input
                {...inputProps}
                type={visible ? 'text' : 'password'}
                style={{ ...style, paddingRight: 44, boxSizing: 'border-box' }}
            />
            <button
                type="button"
                tabIndex={-1}
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? 'Hide password' : 'Show password'}
                title={visible ? 'Hide password' : 'Show password'}
                disabled={inputProps.disabled}
                style={{
                    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', padding: 6,
                    display: 'flex', alignItems: 'center', color: toggleColor,
                }}
            >
                {visible ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
        </div>
    );
}
